var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _this4 = this;
var CountryList = /*#__PURE__*/function () {
  "use strict";

  function CountryList() {
    var _this = this;
    _classCallCheck(this, CountryList);
    this.data = require('./data.json');
    this.labelMap = {};
    this.valueMap = {};
    this.data.forEach(function (country) {
      _this.labelMap[country.label.toLowerCase()] = country.value;
      _this.valueMap[country.value.toLowerCase()] = country.label;
    });
  }
  return _createClass(CountryList, [{
    key: "getValue",
    value: function getValue(label) {
      return this.labelMap[label.toLowerCase()];
    }
  }, {
    key: "getLabel",
    value: function getLabel(value) {
      return this.valueMap[value.toLowerCase()];
    }
  }, {
    key: "getLabels",
    value: function getLabels() {
      return this.data.map(function (country) {
        return country.label;
      });
    }
  }, {
    key: "getValues",
    value: function getValues() {
      return this.data.map(function (country) {
        return country.value;
      });
    }
  }, {
    key: "getLabelList",
    value: function getLabelList() {
      return this.labelMap;
    }
  }, {
    key: "getValueList",
    value: function getValueList() {
      return this.valueMap;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "setLabel",
    value: function setLabel(value, label) {
      var _this2 = this;
      this.data.forEach(function (country) {
        if (country.value === value) {
          country.label = label;
          _this2.valueMap[country.value.toLowerCase()] = country.label;
        }
      });
      return this;
    }
  }, {
    key: "setEmpty",
    value: function setEmpty(label) {
      this.data.unshift({
        value: '',
        label: label
      });
      this.valueMap[''] = label;
      this.labelMap[label] = '';
      return this;
    }
  }, {
    key: "native",
    value: function native() {
      var _this3 = this;
      this.nativeData = require('./data-native.json');
      this.nativeData.forEach(function (country) {
        _this3.labelMap[country.label.toLowerCase()] = country.value;
        _this3.valueMap[country.value.toLowerCase()] = country.label;
      });
      return this;
    }
  }]);
}();
var countryList = function countryList() {
  if (!(_this4 instanceof CountryList)) return new CountryList();
};
module.exports = countryList;